<template>
  <section>
    <div class="z-card integration-page">
      <h4>{{ $t('integration.api.user_info') }}</h4>

      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/auth/me</li>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> POST</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>

      <p>
        {{ $t('integration.api.answer_example') }}
      </p>
      <pre>
<code class="json hljs">
{
    <span class="hljs-attr">"role"</span>:<span class="hljs-string">"client"</span>,
    <span class="hljs-attr">"name"</span>:<span class="hljs-string">"User"</span>,
    <span class="hljs-attr">"phone"</span>:<span class="hljs-string">"70000000000"</span>,
    <span class="hljs-attr">"email"</span>:<span class="hljs-string">"user@zorra.com"</span>,
    <span class="hljs-attr">"timezone"</span>:<span class="hljs-string">"UTC"</span>,
    <span class="hljs-attr">"balance"</span>:<span class="hljs-string">"1.000000"</span>,
    <span class="hljs-attr">"currency"</span>:<span class="hljs-string">"USD"</span>
}

</code>
        </pre>
    </div>
  </section>
</template>

<script>
  export default {};
</script>
<style lang="scss">
  @import '~@/assets/styles/scss/highlight/monokai';
  @import '~@/assets/styles/scss/pages/integration';
</style>
